import React from 'react';
import {motion} from 'framer-motion'
import {fadeIn} from '../variants'

const services = [
    {
        name: 'WEB AND MOBILE DEVELOPMENT',
        description: 'Our coding virtuosos breathe life into your ideas using languages like JavaScript and Node.js. Crafting responsive websites and fluid mobile apps is our forte.',
    },
    {
        name: 'BLOCKCHAIN AND CRYPTO',
        description: 'Dive into the blockchain universe with us. We Are fluent in Solidity, the language of smart contracts, and we specialize in creating crypto solutions that redefine possibilities.',
    },
    {
        name: 'DATA SCIENCE AND AI',
        description: 'Python and PyTorch are our weapons of choice in the data science arena. We unravel insights, build predictive models, and create AI-powered systems that make data work for you.',
    },
    {
        name: 'GAMING AND VR',
        description: 'From 3D models in Unity to creating interactive experiences using C#, we Are the architects behind gaming marvels and virtual reality adventures.',
    },
    {
        name: 'E-COMMERCE SOLUTIONS',
        description: 'With HTML, CSS, and JavaScript, we conjure up e-commerce platforms that blend aesthetics with functionality, delivering a shopping experience that users wont forget.',
    },
]

const Services = () => {
    return (
        <section className=' lg:section min-h-[96vh] xl:min-h[720px] lg:min-h-[620px]' id='services'>
            <div className="container mx-auto">
                <div className='flex flex-col lg:flex-row'>

                    <motion.div
                        variants={fadeIn('left', 0.5)}
                        initial="hidden"
                        whileInView={'show'}
                        viewport={{amount: 0.3, once: true}}
                        className='flex-1'>
                        <div className=''>{services.map((service, index) => {
                            const {name, description, link} = service;
                            return (
                                <div className='border-b border-white/20 h-[146px] mb-[38px] flex' key={index}>
                                    <div className='max-w-[476px]'>
                                        <h4 className='text-[20px] tracking-wider font-secondary text-4xl font-semibold mb-2'>{name}</h4>
                                        <p className='font-secondary leading-tight'>{description}</p>
                                    </div>
                                    
                                </div>
                                
                            );
                            
                        })}
                        </div>
                    </motion.div>
                    
                </div>
            </div>
    
        </section>
        
    );
    
};

export default Services;
